// Author Lin
// Date 2021-12-07 18:43:43

class MintalMesPrdSmeltingElectrodePaste {
        constructor({
                id = null,
                measureTime = '',
                locationId = '',
                locationName = '',
                furnaceId = '',
                furnaceName = '',
                alphaPressureNumber = '',
                bravoPressureNumber = '',
                charliePressureNumber = '',
                additionA = '',
                additionB = '',
                additionC = '',
                electrodeDownA = '',
                electrodeDownB = '',
                electrodeDownC = '',
                pasteTempA = '',
                pasteTempB = '',
                pasteTempC = '',
                liquidPasteA = '',
                liquidPasteB = '',
                liquidPasteC = '',
                solidPasteA = '',
                solidPasteB = '',
                solidPasteC = '',
                barrelHeightA = '',
                barrelHeightB = '',
                barrelHeightC = '',
                remark = ''}
        = {}) {
            this.id = id;
            this.measureTime = measureTime;
            this.locationId = locationId;
            this.locationName = locationName;
            this.furnaceId = furnaceId;
            this.furnaceName = furnaceName;
            this.alphaPressureNumber = alphaPressureNumber;
            this.bravoPressureNumber = bravoPressureNumber;
            this.charliePressureNumber = charliePressureNumber;
            this.additionA = additionA;
            this.additionB = additionB;
            this.additionC = additionC;
            this.electrodeDownA = electrodeDownA;
            this.electrodeDownB = electrodeDownB;
            this.electrodeDownC = electrodeDownC;
            this.pasteTempA = pasteTempA;
            this.pasteTempB = pasteTempB;
            this.pasteTempC = pasteTempC;
            this.liquidPasteA = liquidPasteA;
            this.liquidPasteB = liquidPasteB;
            this.liquidPasteC = liquidPasteC;
            this.solidPasteA = solidPasteA;
            this.solidPasteB = solidPasteB;
            this.solidPasteC = solidPasteC;
            this.barrelHeightA = barrelHeightA;
            this.barrelHeightB = barrelHeightB;
            this.barrelHeightC = barrelHeightC;
            this.remark = remark;
        }
        }
        
        function newEntity() {
        return new MintalMesPrdSmeltingElectrodePaste();
        }
        
            function gridFields() {
            return Object.freeze([
                {
                key: 'id',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.grid.id',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'measureTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.grid.measureTime',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.grid.locationName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'furnaceName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.grid.furnaceName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'alphaPressureNumber',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.grid.alphaPressureNumber',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'bravoPressureNumber',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.grid.bravoPressureNumber',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'charliePressureNumber',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.grid.charliePressureNumber',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'additionA',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.grid.additionA',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'additionB',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.grid.additionB',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'additionC',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.grid.additionC',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'electrodeDownA',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.grid.electrodeDownA',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'electrodeDownB',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.grid.electrodeDownB',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'electrodeDownC',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.grid.electrodeDownC',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'pasteTempA',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.grid.pasteTempA',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'pasteTempB',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.grid.pasteTempB',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'pasteTempC',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.grid.pasteTempC',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'liquidPasteA',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.grid.liquidPasteA',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'liquidPasteB',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.grid.liquidPasteB',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'liquidPasteC',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.grid.liquidPasteC',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'solidPasteA',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.grid.solidPasteA',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'solidPasteB',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.grid.solidPasteB',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'solidPasteC',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.grid.solidPasteC',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'barrelHeightA',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.grid.barrelHeightA',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'barrelHeightB',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.grid.barrelHeightB',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'barrelHeightC',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.grid.barrelHeightC',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.grid.remark',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'textarea'
                }
                }
            ])}
        
        const filter = {
            idFilter : '',
            idListFilter : [],
            measureTimeRteFilter : '',
            measureTimeLteFilter : '',
            locationIdFilter : '',
            locationNameFilter : '',
            furnaceIdFilter : '',
            furnaceNameFilter : '',
            alphaPressureNumberFilter : '',
            bravoPressureNumberFilter : '',
            charliePressureNumberFilter : '',
            additionAFilter : '',
            additionBFilter : '',
            additionCFilter : '',
            electrodeDownAFilter : '',
            electrodeDownBFilter : '',
            electrodeDownCFilter : '',
            pasteTempAFilter : '',
            pasteTempBFilter : '',
            pasteTempCFilter : '',
            liquidPasteAFilter : '',
            liquidPasteBFilter : '',
            liquidPasteCFilter : '',
            solidPasteAFilter : '',
            solidPasteBFilter : '',
            solidPasteCFilter : '',
            barrelHeightAFilter : '',
            barrelHeightBFilter : '',
            barrelHeightCFilter : ''
        };
        
        const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
        
        const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
        
        const filterConfigs = [
                {
                key: 'measureTimeRteFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.filter.measureTimeRte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'measureTimeLteFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.filter.measureTimeLte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'locationNameFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.filter.locationName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'furnaceNameFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.filter.furnaceName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'mintalMesMstFurnace'
                    ,correspondingField: 'furnaceName'
                    ,fieldsBindingByEntityModalSelected: '{"furnaceId":"id"}'
                        }
                },
        ];
        
        
            const entityFormConfigs = [
                {
                key: 'measureTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.entity.measureTime',
                sortable: true,
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.entity.locationName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,required: true
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'furnaceName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.entity.furnaceName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,required: true
                    ,entity: 'mintalMesMstFurnace'
                    ,correspondingField: 'furnaceName'
                    ,fieldsBindingByEntityModalSelected: '{"furnaceId":"id"}'
                        }
                },
                {
                key: 'alphaPressureNumber',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.entity.alphaPressureNumber',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'bravoPressureNumber',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.entity.bravoPressureNumber',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'charliePressureNumber',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.entity.charliePressureNumber',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'additionA',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.entity.additionA',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'additionB',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.entity.additionB',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'additionC',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.entity.additionC',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'electrodeDownA',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.entity.electrodeDownA',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'electrodeDownB',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.entity.electrodeDownB',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'electrodeDownC',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.entity.electrodeDownC',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'pasteTempA',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.entity.pasteTempA',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'pasteTempB',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.entity.pasteTempB',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'pasteTempC',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.entity.pasteTempC',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'liquidPasteA',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.entity.liquidPasteA',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'liquidPasteB',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.entity.liquidPasteB',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'liquidPasteC',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.entity.liquidPasteC',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'solidPasteA',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.entity.solidPasteA',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'solidPasteB',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.entity.solidPasteB',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'solidPasteC',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.entity.solidPasteC',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'barrelHeightA',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.entity.barrelHeightA',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'barrelHeightB',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.entity.barrelHeightB',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'barrelHeightC',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.entity.barrelHeightC',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodePaste.entity.remark',
                sortable: true,
                disabled: false,
                form: {
                type: 'textarea'
                        }
                }
        ]
        
        export {MintalMesPrdSmeltingElectrodePaste, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
        , filterConfigs
        
        
        }
        